import { MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "../Reveal";
import { CITIES, IMAGES } from "../../lib/data";

const ServiceArea = () => (
  <section data-testid="service-area-section" className="border-t border-black/10">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-32">
      <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <Eyebrow>Service Area</Eyebrow>
          <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Serving Petroleum Retailers Across Southern Ontario
          </h2>
          <p className="mt-6 text-base leading-relaxed text-mist md:text-lg">
            Based in Milton, Petroline Services supports fuel stations, convenience stores, car
            washes and commercial properties throughout the Greater Toronto Area and surrounding
            communities.
          </p>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {CITIES.map((city) => (
              <span
                key={city}
                data-testid={`city-chip-${city.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="flex items-center gap-2 border border-black/15 bg-white px-4 py-2 text-xs font-bold uppercase tracking-wider text-neutral-700"
              >
                <MapPin className="h-3.5 w-3.5 text-ember" />
                {city}
              </span>
            ))}
            <span className="flex items-center gap-2 border border-ember/40 bg-ember/10 px-4 py-2 text-xs font-bold uppercase tracking-wider text-ember">
              + Surrounding Communities
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="relative">
          <div className="absolute -inset-10 -z-10 rounded-full bg-ember/15 blur-3xl" aria-hidden="true" />
          <div className="absolute -right-4 -top-4 h-full w-full border border-ember/40" aria-hidden="true" />
          <img
            src={IMAGES.highway.url}
            alt={IMAGES.highway.alt}
            loading="lazy"
            className="relative aspect-[4/3] w-full object-cover"
          />
          <div className="absolute bottom-0 right-0 bg-white px-5 py-3">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-ember">
              Southern Ontario Coverage
            </span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default ServiceArea;
